const RUNTIME_PLACEHOLDER_PREFIX = 'VITE_RUNTIME_';

/**
 * Resolves a `VITE_` variable that `docker-entrypoint.sh` rewrites when the container starts.
 *
 * Vite inlines the build-time value — the literal `VITE_RUNTIME_<NAME>` sentinel from `.env.build` —
 * into the bundle, and the entrypoint substitutes it only for variables present in the container's
 * env. A deployment that sets nothing therefore ships the sentinel itself, which is a non-empty
 * string: `??` and plain truthiness both let it through as if it were a real value.
 *
 * Compare the sentinel here rather than at the use site. `import.meta.env.X === 'literal'` is a
 * comparison of two build-time constants, which the bundler folds away along with the sentinel the
 * entrypoint needs to find; a `startsWith` call on the inlined string is not folded.
 */
export const resolveRuntimeEnvironment = <T extends string>(value: string | undefined, fallback: T): string | T => {
  if (!value || value.startsWith(RUNTIME_PLACEHOLDER_PREFIX)) {
    return fallback;
  }
  return value;
};
